import React from "react";

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
    titleObject: Record<string, string>;
    checkedObject: Record<string, boolean>;
}

const Radio: React.FC<RadioProps> = ({ titleObject, checkedObject, ...other }) => {
    return (
        <div className="radio-holder">
            {(() => {
                const result: JSX.Element[] = [];

                for (const [key, value] of Object.entries(titleObject)) {
                    result.push(
                        <label key={key}>
                            <input data-at_id={`user_role_${key}`} type="radio" value={value} name={key} checked={checkedObject[key]} {...other} />
                            {value}
                        </label>
                    );
                }

                return result;
            })()}
        </div>
    );
};

export { Radio };
